import { useEffect } from 'react'
import { useStoreState } from '@mortgage-pos/ui/store'
import incense from '@mortgage-pos/ui/incense'
import { useNavigate } from 'react-router-dom'
import { Routes } from '@mortgage-pos/types'

export default function usePhoneFlowRedirect() {
  const navigate = useNavigate()
  const { isPhoneFlow } = useStoreState((state) => state.questionnaire)

  const { applicationGuid } = useStoreState((state) => state.application)

  useEffect(() => {
    if (!applicationGuid && isPhoneFlow) {
      incense()
        .details({
          name: 'PhoneAppFlowError',
          message: 'No ApplicationGuid found',
        })
        .error()

      return navigate(`/${Routes.APP_1003}/contact-loan-officer`)
    }
  })
}
